import React from 'react';
import classNames from 'classnames';
import { NavLink } from '../../components/NavLink';
import { DropdownNav } from '../../components/DropdownNav';

import './NavList.scss';

const defaultItem={
  title: '',
  position: 'left',
  target: '_self',
  type: 'redirect',
};

export const NavList = (props) => {
  const {
    item = defaultItem,
    isSecondary,
    onMouseOver,
    onMouseLeave,
    isOffer,
    isSelected = false,
    isDesktop = false,
    isShowChild = false,
    level
  } = props;
  var itemClass;

  const levelUp = (n) => {
    return n + 1;
  };

  const switchClass = (level) => {
    switch (level) {
      case 0:
        itemClass = 'primary-nav-item';
        break;

      case 1:
        itemClass = 'secondary-nav-item';
        break;

      case 2:
        itemClass = 'tertiary-nav-item';
        break;

      default:
        itemClass = '';
    }

    return itemClass;
  };

  return (
    <li
      className={classNames(
        switchClass(level),
        item.position === 'right' ? 'push-left' : '',
        item.rel === "login" ? 'login' : '',
        item.rel === "callcenter" ? 'callcenter' : '',
        item.rel === "account" ? 'account-nav-item' : '',
        item.rel === "offer" ? 'offer-nav-item' : '',
        item.childItems ? 'has-dropdown' : '',
      )} 
    >
      {item.rel === "offer" &&
        <NavLink
          isSecondary={isSecondary}
          item={item}
          isWithStyle
          isSelected={isSelected}
          isDesktop={isDesktop}
          parentHasDropdown={item.childItems ? true : false}
          level={level}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        />
      }
      
      {item.rel === "login" &&
        <NavLink
          isSecondary={isSecondary}
          item={item}
          isWithStyle
          isSelected={isSelected}
          parentHasDropdown={item.childItems ? true : false}
          level={level}
        />
      }

      {item.rel === "callcenter" &&
        <NavLink
          isSecondary={isSecondary}
          item={item}
          isWithStyle
          isSelected={isSelected}
          level={level}
        />
      }
      
      {!item.rel &&
        <NavLink
          isSecondary={isSecondary}
          item={item}
          isWithStyle
          isSelected={isSelected}
          isDesktop={isDesktop}
          parentHasDropdown={item.childItems ? true : false}
          level={level}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        />
      }

      {item.childItems && (
        <DropdownNav
          level={levelUp(level)}
          isOffer={item.rel === "offer" ? true : false }
          isSecondary={isSecondary}
          menu={item.childItems}
          isSelected={isSelected}
          isShowChild={isShowChild}
          isDesktop={isDesktop}
          position={item.position}
        />
      )}
    </li>
  );
};
